<template>
    <div class='mobile_summary'>
        <div class='grid_view_expand'
            :class="{
                'exp-1': index % 4 == 1,
                'exp-2': index % 4 == 2,
                'exp-3': index % 4 == 3,
                'exp-4': index % 4 == 0
            }">

            <!-- Grid view Dropdown summary -->
            <div class='media'>
                <!-- Images -->
                <div class='media-left media-top'>
                    <div class='media-object media-expanded clickable'>
                        <remote-thumbnail-viewer :object='object' height='300' width='300'></remote-thumbnail-viewer>
                    </div>
                </div>
                <div class='media-body'>
                    <div class='row'>
                        <div class='col-md-12'>
                            <router-link :to="{name: 'object', params: {id: object._id}}">
                                <h4 class='summary-title fake-link truncate' :title='object.searchable.title[0]'>{{object.searchable.title[0]}}</h4>
                            </router-link>
                        </div>
                    </div>

                    <!-- The Rest of the details -->
                    <!-- Archives -->
                    <archival-collection-summary v-if='object._index == "archival_collection"' :object='object'></archival-collection-summary>
                    <archival-series-summary v-if='object._index == "archival_series"' :object='object'></archival-series-summary>
                    <archival-fileunit-summary v-if='object._index == "archival_fileunit"' :object='object'></archival-fileunit-summary>
                    <archival-item-summary v-if='object._index == "archival_item"' :object='object'></archival-item-summary>

                    <!-- Collection Objects -->
                    <collection-summary v-else-if='object._index == "mariners_collection"' :object='object'></collection-summary>
                    <collection-summary v-else-if='object._index == "monitor_collection"' :object='object'></collection-summary>

                    <!-- Library Objects -->
                    <library-summary v-else-if='object._index == "library"' :object='object'></library-summary>

                    <!-- Exhibits -->
                    <exhibit-summary v-else-if='object._index == "exhibit"' :object='object'></exhibit-summary>

                    <!-- Associations -->
                    <association-summary v-else-if='object._index == "association"' :object='object'></association-summary>

                    <!-- Vessel -->
                    <vessel-summary v-else-if='object._index == "vessel"' :object='object'></vessel-summary>

                    <!-- Image Thumbnails -->
                    <div class='pull-left reference' v-incremental-scroll='{back: indexBack, forward: indexForward, is_horz: true}'>
                        <div class='arrows clickable incremental-scroll-back'>
                            <img src='/images/arrow_large_white.svg'>
                        </div>
                        <div class='scroll-wrapper'>
                            <div v-for='(m, index) in media'>
                                <img class='thumbnails clickable'
                                    @click='goToPage(index)'
                                    :title='m.title'
                                    :src="m.thumbnail_path"
                                    :class='{"selected": selected == index}'>
                            </div>
                        </div>
                        <div class='arrows clickable incremental-scroll-forward'>
                            <img class='rotate180' src='/images/arrow_large_white.svg'>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import EventHub from '../eventHub.js'
    import MobileManager from '../mobileManager.js'
    import RemoteThumbnailViewerVue from './../remoteThumbnailViewer.vue'
    import CollectionSummaryVue from './collectionSummary.vue'
    import ArchivalCollectionSummaryVue from './archivalCollectionSummary.vue'
    import ArchivalSeriesSummaryVue from './archivalSeriesSummary.vue'
    import ArchivalFileunitSummaryVue from './archivalFileunitSummary.vue'
    import ArchivalItemSummaryVue from './archivalItemSummary.vue'
    import LibrarySummaryVue from './librarySummary.vue'
    import ExhibitSummaryVue from './exhibitSummary.vue'
    import AssociationSummaryVue from './associationSummary.vue'
    import VesselSummaryVue from './vesselSummary.vue'
    import MediaParser from '../../mixins/mediaParser.js'
    import Media from '../../mixins/Media.js'

    export default {
        props: ['objWithSource', 'index'],
        mixins: [MediaParser],
        data: function () {
            return {
                selected: 0,
                mobile_manager: MobileManager,
                media: []
            }
        },
        created: function () {
            var self = this
            // When the component is first mounted fetch search data
            this.$nextTick(function () {
                self.media = self.parseMedia(self.object, 75, 75)
                self.media = self.addFolderImage(self.object, self.media, 75, 75)
                self.media = self.addNoImage(self.object, self.media, 75, 75)
            })
        },
        computed: {
            object: function () {
                var object = this.objWithSource._source
                object._index = this.objWithSource._index
                object._id = this.objWithSource._id
                return object
            }
        },
        methods: {
            viewEnlarged: function () {
                EventHub.$emit('view-enlarged', {object: this.object})
            },
            goToPage: function (index) {
                this.selected = index
                EventHub.$emit('change-index', {id: this.object._id, index: this.selected})
            },
            indexBack: function () {
                var index = this.selected - 1
                if (index < 0) {
                    this.goToPage(this.media.length - 1)
                    return
                }

                this.goToPage(index)
            },
            indexForward: function () {
                var index = this.selected + 1
                if (index >= this.media.length) {
                    this.goToPage(0)
                    return
                }

                this.goToPage(index)
            },
        },
        components: {
            'remote-thumbnail-viewer': RemoteThumbnailViewerVue,
            'collection-summary': CollectionSummaryVue,
            'archival-collection-summary': ArchivalCollectionSummaryVue,
            'archival-series-summary': ArchivalSeriesSummaryVue,
            'archival-fileunit-summary': ArchivalFileunitSummaryVue,
            'archival-item-summary': ArchivalItemSummaryVue,
            'library-summary': LibrarySummaryVue,
            'exhibit-summary': ExhibitSummaryVue,
            'association-summary': AssociationSummaryVue,
            'vessel-summary': VesselSummaryVue
        }
    };
</script>

<style lang="scss">
    @import '../../../sass/variables.scss';
    /* CSS for grid dropdown. Div after every image */
    .mobile_summary {
        color: white;
        margin-bottom: 15px;

        .grid_view_expand {
            padding: 10px;
            background-color: $dark_gray;
            width: 100%;
        }

        .grid_view_expand:after {
            bottom: 100%;
            left: 11%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-bottom-color: $dark_gray;
            border-width: 10px;
            margin-left: -10px;
        }

        .media-body {
            height: 100%;
        }

        .reference {
            width: 100%;
            margin-top: 10px;
            overflow: hidden;
            white-space: nowrap;
            position: relative;
        }

        .scroll-wrapper {
            margin-right: 20px;
            margin-left: 20px;
            overflow-x: hidden;

            div {
                display: inline;
            }
        }

        .arrows {
            position: absolute;
            transform: translateY(-50%);
            top: 50%;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .incremental-scroll-forward {
            right: 0;
        }

        .thumbnails {
            padding: 5px;
            display: inline;
            width: auto;
            max-width: 75px;
        }

        .media-expanded {
            padding-top: 10px;
            width: 300px;
        }

        .exp-1:after {
            left: 11%;
        }

        .exp-2:after {
            left: 36%;
        }

        .exp-3:after {
            left: 61%;
        }

        .exp-4:after {
            left: 86%;
        }

        h4, .btn {
            color: white;
        }

        .btn {
            background-color: $dark_med_gray;
        }

        a, .fake-link {
            color: $sky_blue;
        }
    }
</style>
